import React from 'react';

import { Button, Stack, Typography } from '@mui/material';

interface Props {
  onChoose: (choice: 'room_rate' | 'room_type') => void;
  roomTypeName: string;
}

export default function OfferInventoryScopeChoice({ roomTypeName, onChoose }: Props) {
  return (
    <Stack spacing={2} sx={{ p: 3, border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Typography variant="body1">{roomTypeName} has no inventory cap yet. How would you like to set it up?</Typography>
      <Stack direction="row" spacing={2} flexWrap="wrap">
        <Button variant="outlined" onClick={() => onChoose('room_type')}>
          Cap this room type as a whole
        </Button>
        <Button variant="outlined" onClick={() => onChoose('room_rate')}>
          Cap individual rates
        </Button>
      </Stack>
      <Typography variant="caption" color="text.secondary">
        Every rate under this room type will share one cap, or you can set a separate cap per rate — once you set your
        first cap, that choice is locked in until every cap for this room type is cleared.
      </Typography>
    </Stack>
  );
}
